import React from 'react';
import AccountBasicInfoComponent from './add-account.components';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import { AddressContainer } from '../../../../../../common/address/containers/address.container';
import CustomerUserProfileInfoComponent from './customer-userProfile.component';
import CustomerLoginInfoComponent from './customer-login-info.component';
import CustomerAccountInfoComponent from './customer-account-info.component';

export const CustomerComponent = ({accounts,handleBasicInnerFormChange,selectedCustomers,id,selectedAccounts, handleInnerFormChange, back, handleFormSubmit }: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'Customer-Info',
            component: (
                <AccountBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedAccounts={selectedAccounts}
                />
            ),
            isVisible: id === String(0) ? true : false,
        },
        {
            id: 2,
            title: 'Basic-Info',
            component: (
                <CustomerUserProfileInfoComponent
                onBasicInnerFormChange={handleBasicInnerFormChange}
                onInnerFormChange ={handleInnerFormChange}
                selectedCustomers={selectedCustomers}
                />
            ),
            isVisible:id > 0 ? true : false
        },
        {
            id: 3,
            title: 'Login-Info',
            component: (
                <CustomerLoginInfoComponent
                onInnerFormChange ={handleInnerFormChange}
                selectedCustomers= {selectedCustomers}
                />
            ),
            isVisible:id > 0 ? true : false
        },
        {
            id: 4,
            title: 'Account-Info',
            component: (
                <CustomerAccountInfoComponent
                accounts={accounts}
                onInnerFormChange ={handleInnerFormChange}
                selectedCustomers={selectedCustomers}
                />
            ),
            isVisible:id > 0 ? true : false
        },
        {
            id: 5,
            title: 'Address-Info',
            component: (
                <AddressContainer
                onInnerFormChange={handleInnerFormChange}
                selectedCustomers={selectedCustomers}
                />
            ),
            isVisible:id > 0 ? true : false
        },
      
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default CustomerComponent;
